import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './core/interceptors/loading.interceptor';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CoreModule } from './core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { CookieModule } from 'ngx-cookie';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { ToastModule } from 'primeng/toast';
import { GlobalErrorHandler } from './core/util/global-error-handler';
import { APP_INITIALIZER } from '@angular/core';
import { initialiseMockLayer, mockProviders } from './mock/mock.providers';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpClientModule,
    CoreModule,
    SharedModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    NgxSpinnerModule,
    ToastModule,
    
    CookieModule.withOptions(),
    NgxWebstorageModule.forRoot({ prefix: '', separator: '', caseSensitive: true }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    // Showcase build. Empty array when environment.useMock is false — see contracts-1 §11.1.
    ...mockProviders,
    { provide: APP_INITIALIZER, useValue: initialiseMockLayer, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
